import styled from 'styled-components';
import { WrapperDefault } from '../../Shared/Shared';

export const FormInfoWrapper = styled(WrapperDefault)`
  gap: 15px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const ProssecingPayment = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  span {
    font-size: 20px;
    font-weight: bold;
  }
`;

export const FormBody = styled.p`
  margin-top: 24px;
  margin-bottom: 42px;
  font-weight: 500;
  line-height: 1.45;
  font-size: 20px;
`;

export const QrCodeWrapper = styled.div`
  height: 145px;
  width: 145px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DownloadButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  width: 139px;
  height: 45px;
  font-size: 16px;
  border-radius: 22.5px;
  background-color: var(--black);
  color: var(--white);
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

export const CheckmarkBox = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid var(--text-primary);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 37px;
  svg {
    stroke: var(--text-primary);
    stroke-width: 1px;
    fill: var(--text-primary);
    height: 35px !important;
    width: 35px !important;
  }
`;
